var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMp4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 3C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H9",
    stroke: "#067BF9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10V3.5L16 3",
    stroke: "#067BF9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12C12.3284 12 13 11.3284 13 10.5C13 9.67157 12.3284 9 11.5 9C10.6716 9 10 9.67157 10 10.5C10 11.3284 10.6716 12 11.5 12Z",
    stroke: "#067BF9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 24,
    height: 10,
    rx: 2,
    fill: "#067BF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.456 22L4.568 15.52H6.104L6.816 19.288L7.584 15.52H9.064L9.176 22H8.16L8.04 17.688L7.288 22H6.384L5.584 17.656L5.488 22H4.456ZM10.5928 22V15.52H12.7688C13.1581 15.52 13.4781 15.5947 13.7288 15.744C13.9795 15.888 14.1661 16.1013 14.2888 16.384C14.4115 16.6613 14.4728 17 14.4728 17.4C14.4728 17.9013 14.3901 18.2853 14.2248 18.552C14.0595 18.8133 13.8355 18.9947 13.5528 19.096C13.2701 19.1973 12.9528 19.248 12.6008 19.248H12.0248V22H10.5928ZM12.0248 18.248H12.5048C12.6808 18.248 12.8141 18.216 12.9048 18.152C12.9955 18.088 13.0541 17.992 13.0808 17.864C13.1128 17.736 13.1288 17.5733 13.1288 17.376C13.1288 17.2107 13.1155 17.0667 13.0888 16.944C13.0675 16.816 13.0115 16.7147 12.9208 16.64C12.8301 16.5653 12.6888 16.528 12.4968 16.528H12.0248V18.248ZM17.3551 22V20.544H15.3631V19.56L17.0511 15.52H18.6031V19.552H19.2031V20.544H18.6031V22H17.3551ZM16.3791 19.552H17.3551V16.856L16.3791 19.552Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp4);
export default __webpack_public_path__ + "static/media/mp4.ad3f19c03da88a907157c7f2d5f2f084.svg";
export { ForwardRef as ReactComponent };